import React, { useState, useEffect } from "react";
import Loading from "../../Common/Loading";
import CustomAlert from "../../Common/CustomAlert";
import save_n from "../../Common/Images/save_n.gif";
import save_o from "../../Common/Images/save_o.gif";
import cancel_n from "../../Common/Images/cancel_n.gif";
import cancel_o from "../../Common/Images/cancel_o.gif";

const API_BASE_URL =
  process.env.REACT_APP_DOCUMENT_LINK;

interface CountryType {
  Major: string;
  Minor?: string;
}

const EL_AddEditStates: React.FC = () => {
  const [countries, setCountries] = useState<CountryType[]>([]);

  const [selectedCountry, setSelectedCountry] = useState<string>("");
  const [stateName, setStateName] = useState<string>("");
  const [timeDiff, setTimeDiff] = useState<string>("");

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [alertInfo, setAlertInfo] = useState({
    show: false,
    message: "",
    isSuccess: false,
  });

  const [isSaveHovered, setIsSaveHovered] = useState(false);
  const [isCancelHovered, setIsCancelHovered] = useState(false);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}api/get_countries/`);
        const data = await res.json();

        if (Array.isArray(data?.countries)) {
          const formatted = data.countries.map((c: string) => ({ Major: c }));
          setCountries(formatted);
          if (formatted.length > 0) {
            setSelectedCountry(formatted[0].Major);
          }
        }
      } catch (error) {
        console.error("Failed to fetch countries", error);
      }
    };

    fetchCountries();
  }, []);

  const handleTimeDiffChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (/^-?\d*\.?\d*$/.test(val)) {
      setTimeDiff(val);
    }
  };

  const handleSave = async () => {
    if (!selectedCountry || !stateName || !timeDiff) {
      setAlertInfo({
        show: true,
        message: "Please Enter all values",
        isSuccess: false,
      });
      return;
    }

    setIsLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}api/manage_states/add/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          country: selectedCountry,
          stateName: stateName,
          timeDiff: timeDiff,
        }),
      });

      const result = await response.json();
      if (result.status === "success") {
        if (window.opener) {
          window.opener.postMessage("stateAdded", "*");
        }
        window.close();
      } else {
        setAlertInfo({ show: true, message: result.message, isSuccess: false });
      }
    } catch (error) {
      console.error("Save failed", error);
      setAlertInfo({
        show: true,
        message: "Failed to save due to network error.",
        isSuccess: false,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseAlert = () => {
    setAlertInfo({ show: false, message: "", isSuccess: false });
  };

  return (
    <div
      style={{
        margin: 0,
        backgroundColor: "#fff",
        fontFamily: "Arial",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {isLoading && <Loading />}

      <div style={{ textAlign: "center", fontFamily: "Arial", margin: "10px" }}>
        <table
          style={{ width: "100%", fontFamily: "Arial" }}
          cellPadding={0}
          cellSpacing={0}
        >
          <tbody>
            <tr>
              <td style={{ width: "2%" }}>&nbsp;</td>
              <td
                style={{
                  border: "1px solid black",
                  textAlign: "center",
                  width: "96%",
                  backgroundColor: "#B5DCED",
                  color: "#0000FF",
                  padding: "5px",
                }}
              >
                <b>ADDING STATE</b>
              </td>
              <td style={{ width: "2%" }}>&nbsp;</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        style={{
          padding: "10px",
          textAlign: "center",
          fontFamily: "Arial",
          fontSize: "13px",
        }}
      >
        <table style={{ width: "100%", fontFamily: "Arial" }}>
          <tbody>
            <tr>
              <td style={{ width: "2%" }}>&nbsp;</td>
              <td
                align="right"
                style={{
                  textAlign: "right",
                  width: "48%",
                  paddingRight: "10px",
                  fontWeight: "bold",
                }}
              >
                Country:
              </td>
              <td style={{ textAlign: "left", width: "48%", padding: "10px" }}>
                <select
                  value={selectedCountry}
                  onChange={(e) => setSelectedCountry(e.target.value)}
                  style={{ width: "200px", padding: "3px" }}
                >
                  {/* <option value="">-- Select --</option> */}
                  {countries.map((c, idx) => (
                    <option key={idx} value={c.Major}>
                      {c.Major}
                    </option>
                  ))}
                </select>
              </td>
              <td style={{ width: "2%" }}>&nbsp;</td>
            </tr>
            <tr>
              <td>&nbsp;</td>
              <td
                align="right"
                style={{ paddingRight: "10px", fontWeight: "bold" }}
              >
                State:
              </td>
              <td style={{ textAlign: "left", padding: "10px" }}>
                <input
                  type="text"
                  value={stateName}
                  onChange={(e) => setStateName(e.target.value)}
                  maxLength={50}
                  style={{
                    width: "194px",
                    border: "1px solid #003300",
                    padding: "3px",
                  }}
                />
              </td>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td>&nbsp;</td>
              <td
                align="right"
                style={{ paddingRight: "10px", fontWeight: "bold" }}
              >
                Time Difference with UTC (Hrs):
              </td>
              <td style={{ textAlign: "left", padding: "10px" }}>
                <input
                  type="text"
                  value={timeDiff}
                  onChange={handleTimeDiffChange}
                  maxLength={5}
                  style={{
                    width: "150px",
                    border: "1px solid #003300",
                    padding: "3px",
                  }}
                />
              </td>
              <td>&nbsp;</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style={{ padding: "10px" }}>
        <table style={{ width: "100%", fontFamily: "Arial" }}>
          <tbody>
            <tr>
              <td style={{ textAlign: "center" }}>
                <img
                  src={isSaveHovered ? save_o : save_n}
                  alt="Save"
                  title="Save New State"
                  onClick={handleSave}
                  onMouseEnter={() => setIsSaveHovered(true)}
                  onMouseLeave={() => setIsSaveHovered(false)}
                  style={{
                    cursor: "pointer",
                    verticalAlign: "middle",
                    marginRight: "15px",
                  }}
                />
                <img
                  src={isCancelHovered ? cancel_o : cancel_n}
                  alt="Cancel"
                  title="Cancel"
                  onClick={() => window.close()}
                  onMouseEnter={() => setIsCancelHovered(true)}
                  onMouseLeave={() => setIsCancelHovered(false)}
                  style={{ cursor: "pointer", verticalAlign: "middle" }}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {alertInfo.show && (
        <CustomAlert message={alertInfo.message} onClose={handleCloseAlert} />
      )}
    </div>
  );
};

export default EL_AddEditStates;
